<!-- Small/Medium viewport -->
<ul class="d-block d-lg-none list-group mb-2" (click)="openEmailPreview()">
  <li class="list-group-item d-flex justify-content-between align-items-center subheader pt-1 pb-1">
    <div class="col-12">
      <strong>{{ 'Request.ReviewSend.Action' | translate }} {{actionIndex}}</strong>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Name</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{actor.fullName}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Email</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{actor.email}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Mobile</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{actor.mobile}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Language</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{actor.language}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Action</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span translate="dashboard.activitylist.actions.{{actor.action}}"></span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Document</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{ getDocumentName(actor.documentId) }}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Deadline</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span *ngIf="isFirstActor || allActorsAreDownloaders">{{ actor.deadline | date:'dd-MM-yyyy HH:mm' }}</span>
      <div *ngIf="!isFirstActor && !allActorsAreDownloaders">
        <span *ngIf="(actor.deadlineDays ?? 0) === 0">{{ actor.deadline | date:'dd-MM-yyyy HH:mm' }}</span>
        <span *ngIf="(actor.deadlineDays ?? 0) === 1" translate [translateParams]="{days: actor.deadlineDays ?? 0, deadlineDay: calculateLatestDeadline(actor.deadlineDays ?? 0) | date:'dd-MM'}">Request.ReviewSend.DeadlineDay</span>
        <span *ngIf="(actor.deadlineDays ?? 0) > 1 && (actor.deadlineDays ?? 0) < 31" translate [translateParams]="{days: actor.deadlineDays ?? 0, deadlineDay: calculateLatestDeadline(actor.deadlineDays ?? 0) | date:'dd-MM'}">Request.ReviewSend.DeadlineDays</span>
        <span *ngIf="(actor.deadlineDays ?? 0) === 31" translate [translateParams]="{month: 1, deadlineDay: calculateLatestDeadline(actor.deadlineDays ?? 0) | date:'dd-MM'}">Request.ReviewSend.DeadlineMonth</span>
        <span *ngIf="(actor.deadlineDays ?? 0) > 31" translate [translateParams]="{months: (actor.deadlineDays ?? 0) === 62 ? 2 : 3, deadlineDay: calculateLatestDeadline(actor.deadlineDays ?? 0) | date:'dd-MM'}">Request.ReviewSend.DeadlineMonths</span>
      </div>
    </div>
  </li>
</ul>

<!-- Large viewport -->
<div class="d-none d-lg-block">
    <div class="row w-100 d-flex p-0 align-items-center">
      <div class="col-2 firstcol text-truncate"><span *ngIf="getIndexOfCurrentActor() == 0">{{actorName}}</span></div>
      <div class="col-2 text-truncate"><span *ngIf="getIndexOfCurrentActor() == 0">{{actor.email}}</span></div>
      <div class="col-2 col-xl-1 text-truncate"><span *ngIf="getIndexOfCurrentActor() == 0">{{actor.mobile}}</span></div>
      <div class="d-none d-xl-block col-1 text-truncate"><span *ngIf="getIndexOfCurrentActor() == 0">{{actor.language}}</span></div>
      <div class="col-1 text-truncate" translate="dashboard.activitylist.actions.{{actor.action}}"></div>
      <div class="col-2 col-xl-3 text-truncate">{{ getDocumentName(actor.documentId) }}</div>
      <div class="col-2 col-xl-1 text-truncate" *ngIf="(isFirstActor && getIndexOfCurrentActor() == 0) || allActorsAreDownloaders">{{ actor.deadline | date:'dd-MM-yyyy HH:mm' }} </div>
      <div class="col-2 col-xl-1 text-truncate" *ngIf="!isFirstActor && getIndexOfCurrentActor() == 0 && !allActorsAreDownloaders">
        <span *ngIf="(actor.deadlineDays ?? 0) === 0">{{ actor.deadline | date:'dd-MM-yyyy HH:mm' }}</span>
        <span *ngIf="(actor.deadlineDays ?? 0) === 1" translate [translateParams]="{days: actor.deadlineDays ?? 0, deadlineDay: calculateLatestDeadline(actor.deadlineDays ?? 0) | date:'dd-MM'}">Request.ReviewSend.DeadlineDay</span>
        <span *ngIf="(actor.deadlineDays ?? 0) > 1 && (actor.deadlineDays ?? 0) < 31" translate [translateParams]="{days: actor.deadlineDays ?? 0, deadlineDay: calculateLatestDeadline(actor.deadlineDays ?? 0) | date:'dd-MM'}">Request.ReviewSend.DeadlineDays</span>
        <span *ngIf="(actor.deadlineDays ?? 0) === 31" translate [translateParams]="{month: 1, deadlineDay: calculateLatestDeadline(actor.deadlineDays ?? 0) | date:'dd-MM'}">Request.ReviewSend.DeadlineMonth</span>
        <span *ngIf="(actor.deadlineDays ?? 0) > 31" translate [translateParams]="{months: (actor.deadlineDays ?? 0) === 62 ? 2 : 3, deadlineDay: calculateLatestDeadline(actor.deadlineDays ?? 0) | date:'dd-MM'}">Request.ReviewSend.DeadlineMonths</span>
      </div>
      <div class="col-2 col-xl-1 text-truncate" *ngIf="getIndexOfCurrentActor() > 0"></div>
      <div class="col-1">
        <span class="float-end">
          <div class="btn-group">
            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item pt-1 pb-1" (click)="openEmailPreview()" translate>Button.ShowInvite</a></li>
            </ul>
          </div>
        </span>
      </div>
    </div>
</div>